import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

import List from '@/components/List'
Vue.component('n-list', List)

import Multiselect from 'vue-multiselect'
Vue.component('n-multiselect', Multiselect)

import Draggable from 'vuedraggable'
Vue.component('n-draggable', Draggable)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
